import { api } from 'trpc/react';

export const useCartItem = (productPriceId?: string | null) => {
    return api.cart.getItem.useQuery(
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        { productPriceId: productPriceId! },
        { enabled: !!productPriceId },
    );
};
